import React__default from "react";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var cjs$1 = {}, AirportProvider = {}, cjs = {}, Airport$1 = {}, types = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Currency = void 0, function(t) {
    t.KRW = "KRW", t.JPY = "JPY", t.USD = "USD";
  }(e.Currency || (e.Currency = {}));
})(types);
var utils = {};
Object.defineProperty(utils, "__esModule", { value: !0 });
utils.roundOperation = utils.deepEqual = utils.createLSFactory = void 0;
function createLSFactory() {
  return function(t) {
    return t;
  };
}
utils.createLSFactory = createLSFactory;
function deepEqual(e, t) {
  if (Number.isNaN(e) && Number.isNaN(t))
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e != "object" || typeof t != "object" || e === null || t === null)
    return e === t;
  const r = Object.keys(e), c = Object.keys(t);
  if (r.length !== c.length)
    return !1;
  for (let u of r)
    if (!deepEqual(e[u], t[u]))
      return !1;
  return !0;
}
utils.deepEqual = deepEqual;
function roundOperation(e, t, r) {
  const c = Math.pow(10, Math.floor(Math.log10(Math.abs(e - t))) + 1);
  return r === "ceil" && t <= e ? t + c : r === "floor" && t >= e ? t - c : t;
}
utils.roundOperation = roundOperation;
Object.defineProperty(Airport$1, "__esModule", { value: !0 });
Airport$1.Airport = void 0;
const types_1 = types, utils_1 = utils;
class Airport {
  constructor(e) {
    var t;
    this.options = e, this.region = null, this.supportedCurrency = [], this.currencyFormatValueKey = "v", this.keyCurrency = types_1.Currency.USD, this.createLS = utils_1.createLSFactory(), this.getOptions = () => Object.assign({}, this.options), this.getLocale = () => this.locale, this.getLanguage = () => this.language, this.getRegion = () => this.region, this.changeLocale = (r) => {
      this.setupLocale(r), this.cachedNumberFormat = new Intl.NumberFormat(r, this.cachedNumberFormatOptions), this.cachedCurrencyFormat = new Intl.NumberFormat(r, this.cachedCurrencyFormatOptions);
    }, this.fn = (r, c, u) => {
      const a = this.getNumberFormatInstance(c, u);
      if (c != null && c.roundingMode) {
        const n = Number(a.format(r).replace(/[^0-9.\-]/g, "")), i = utils_1.roundOperation(r, n, c.roundingMode);
        return a.format(i);
      }
      return a.format(r);
    }, this.fc = (r, c, u, a = !1, n) => {
      if (!this.currencyMap) {
        console.error('You need to set "currency" options for using fc()');
        return;
      }
      const i = n ?? this.getLocale();
      if (a) {
        if (!u) {
          console.error("You cannot fix currency without baseCurrency.");
          return;
        }
        return this.formatCurrency(r, u, c, n);
      }
      const o = this.currencyMap[i];
      if (!u || u === o)
        return this.formatCurrency(r, o, c, n);
      const l = this.exchangeRate[this.keyCurrency], f = this.exchangeRate[u] / l, s = this.exchangeRate[o] / l;
      if (!f || !s)
        return this.formatCurrency(r, u, c, n);
      const p = r / f * s;
      return this.formatCurrency(p, o, c, n);
    }, this.supportedLocales = e.supportedLocales, this.globalLS = (t = e.globalLS) !== null && t !== void 0 ? t : {}, this.setupFallbackLocale(e.fallbackLocale), this.setupLocale(e.locale), this.setupOptions(e), this.t = this.t.bind(this), this.cachedNumberFormat = new Intl.NumberFormat(e.locale, this.cachedNumberFormatOptions), this.cachedCurrencyFormat = new Intl.NumberFormat(e.locale, this.cachedCurrencyFormatOptions);
  }
  t(lsoOrGlobalLSKey, variableMap, _forcedLocale) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let translated = "";
    try {
      const locale = _forcedLocale ?? this.getLocale(), language = _forcedLocale ? this.splitLocale(_forcedLocale)[0] : this.getLanguage(), variableEntries = Object.entries(variableMap ?? {});
      translated = typeof lsoOrGlobalLSKey == "object" ? (_d = (_c = (_b = (_a = lsoOrGlobalLSKey[locale]) !== null && _a !== void 0 ? _a : lsoOrGlobalLSKey[language]) !== null && _b !== void 0 ? _b : lsoOrGlobalLSKey[this.fallbackLocale]) !== null && _c !== void 0 ? _c : lsoOrGlobalLSKey[this.fallbackLanguage]) !== null && _d !== void 0 ? _d : "" : (_h = (_f = (_e = this.globalLS[lsoOrGlobalLSKey]) === null || _e === void 0 ? void 0 : _e[locale]) !== null && _f !== void 0 ? _f : (_g = this.globalLS[lsoOrGlobalLSKey]) === null || _g === void 0 ? void 0 : _g[language]) !== null && _h !== void 0 ? _h : lsoOrGlobalLSKey, variableEntries.forEach(([e, t]) => {
        t === void 0 ? translated = translated == null ? void 0 : translated.replace(new RegExp(`\\{${e}\\}`, "gi"), "") : translated = translated == null ? void 0 : translated.replace(new RegExp(`\\{${e}\\}`, "gi"), t);
      }), translated = translated == null ? void 0 : translated.replace(new RegExp("\\{(.[^\\}]*)\\}", "gi"), (match, p1) => Object.keys(variableMap).every((e) => !(p1 != null && p1.includes(e))) ? match : eval(`${variableEntries.map(([e, t]) => {
        let r = t;
        return typeof r == "string" && (r = r.replace(/['"]+/g, "")), `var ${e} = ${typeof t == "string" ? `'${r}'` : t};`;
      }).join("")}${p1};`));
    } catch (e) {
      console.error(e);
    } finally {
      return translated;
    }
  }
  formatCurrency(e, t, r, c) {
    var u, a;
    let n;
    return r ? n = r : !((u = this.currencyFormat) === null || u === void 0) && u[t] && (n = (a = this.currencyFormat) === null || a === void 0 ? void 0 : a[t]), n ? this.t(n, { [this.currencyFormatValueKey]: this.fn(e) }) : this.getCurrencyFormatInstance({ style: "currency", currency: t }, c).format(e);
  }
  setupLocale(e) {
    if (!e) {
      console.error("There is no input locale.");
      return;
    }
    const [t, r] = this.splitLocale(e);
    if (!this.isSupportedLocale(e, t)) {
      this.useFallbackLocale();
      return;
    }
    this.applyLocale(e, t, r);
  }
  setupFallbackLocale(e) {
    if (!this.isSupportedLocale(e))
      throw new Error("options.fallbackLocale must be value in the options.supportedLocales");
    this.fallbackLocale = e;
    const [t, r] = this.splitLocale(e);
    this.fallbackLanguage = t, this.fallbackRegion = r;
  }
  applyLocale(e, t, r) {
    this.locale = e, this.language = t, this.region = r;
  }
  // Function to renew and return cached instance of NumberFormat.
  getNumberFormatInstance(e, t) {
    return t ? new Intl.NumberFormat(t, e) : (utils_1.deepEqual(this.cachedNumberFormatOptions, e) || (this.cachedNumberFormatOptions = e, this.cachedNumberFormat = new Intl.NumberFormat(this.getLocale(), e)), this.cachedNumberFormat);
  }
  // Function to renew and return cached instance of CurrencyNumberFormat.
  getCurrencyFormatInstance(e, t) {
    return t ? new Intl.NumberFormat(t, e) : (utils_1.deepEqual(this.cachedCurrencyFormatOptions, e) || (this.cachedCurrencyFormatOptions = e, this.cachedCurrencyFormat = new Intl.NumberFormat(this.getLocale(), e)), this.cachedCurrencyFormat);
  }
  useFallbackLocale() {
    this.applyLocale(this.fallbackLocale, this.fallbackLanguage, this.fallbackRegion);
  }
  splitLocale(e) {
    return e.split("-");
  }
  isSupportedLocale(e, t) {
    return this.supportedLocales.includes(e) || t && this.supportedLocales.includes(t);
  }
  setupOptions(e) {
    this.setupCurrency(e);
  }
  setupCurrency(e) {
    var t, r, c;
    if (!(this.currencyMap || !e.currency)) {
      if (this.currencyMap = Object.assign({}, e.currency), this.supportedCurrency = [...Object.values(this.currencyMap)], e.keyCurrency && (this.keyCurrency = e.keyCurrency), !this.supportedCurrency.includes(this.keyCurrency))
        throw new Error("keyCurrency must be included on the options.currency.");
      e.currencyFormatValueKey && (this.currencyFormatValueKey = e.currencyFormatValueKey), e.currencyFormat && (this.currencyFormat = Object.assign({}, e.currencyFormat)), e.exchangeRate && (this.exchangeRate = Object.assign({}, e.exchangeRate), (t = (r = this.exchangeRate)[c = this.keyCurrency]) !== null && t !== void 0 || (r[c] = 1));
    }
  }
}
Airport$1.Airport = Airport;
(function(e) {
  var t = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(u, a, n, i) {
    i === void 0 && (i = n), Object.defineProperty(u, i, { enumerable: !0, get: function() {
      return a[n];
    } });
  } : function(u, a, n, i) {
    i === void 0 && (i = n), u[i] = a[n];
  }), r = commonjsGlobal && commonjsGlobal.__exportStar || function(u, a) {
    for (var n in u)
      n !== "default" && !Object.prototype.hasOwnProperty.call(a, n) && t(a, u, n);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Airport = void 0;
  var c = Airport$1;
  Object.defineProperty(e, "Airport", { enumerable: !0, get: function() {
    return c.Airport;
  } }), r(types, e), r(utils, e);
})(cjs);
(function(e) {
  var t = commonjsGlobal && commonjsGlobal.__rest || function(a, n) {
    var i = {};
    for (var o in a)
      Object.prototype.hasOwnProperty.call(a, o) && n.indexOf(o) < 0 && (i[o] = a[o]);
    if (a != null && typeof Object.getOwnPropertySymbols == "function")
      for (var l = 0, o = Object.getOwnPropertySymbols(a); l < o.length; l++)
        n.indexOf(o[l]) < 0 && Object.prototype.propertyIsEnumerable.call(a, o[l]) && (i[o[l]] = a[o[l]]);
    return i;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.AirportProvider = e.AirportContext = void 0;
  const r = React__default, c = cjs;
  e.AirportContext = r.createContext(null);
  function u(a) {
    var { children: n, airport: i } = a, o = t(a, ["children", "airport"]);
    const l = r.useMemo(() => i || new c.Airport(o), [i]), f = r.useMemo(() => Object.freeze(i ? i.getOptions() : o), [i]), [s, p] = r.useReducer((d) => d + 1, () => 0), h = r.useCallback((d) => {
      l.changeLocale(d), p();
    }, [l]);
    return r.useEffect(() => {
      o.locale && l.getLocale() !== o.locale && h(o.locale);
    }, [l, o.locale]), r.createElement(e.AirportContext.Provider, { value: { airport: l, initialOptions: f, setLocale: h } }, n);
  }
  e.AirportProvider = u;
})(AirportProvider);
var AirportSubtree$1 = {}, useAirport$1 = {};
Object.defineProperty(useAirport$1, "__esModule", { value: !0 });
useAirport$1.useAirport = void 0;
const React$1 = React__default, AirportProvider_1$1 = AirportProvider;
function useAirport() {
  const { airport: e, initialOptions: t, setLocale: r } = React$1.useContext(AirportProvider_1$1.AirportContext), [c, u] = React$1.useState(i()), { fn: a, fc: n } = e;
  React$1.useEffect(() => {
    c.locale !== e.getLocale() && u(i());
  });
  function i() {
    return {
      locale: e ? e.getLocale() : null,
      language: e ? e.getLanguage() : null,
      region: e ? e.getRegion() : null
    };
  }
  function o(f, s, p) {
    if (p === s.length)
      return [f];
    const h = s[p][0], d = s[p][1], y = f.split(new RegExp(`\\{${h}\\}`, "gi")), b = [];
    return y.forEach((m, g) => {
      const _ = o(m, s, p + 1);
      b.push(..._), g < y.length - 1 && b.push(d);
    }), b;
  }
  function l(f, s, p) {
    const h = Object.entries(s ?? {}).filter(([d, y]) => React$1.isValidElement(y));
    if (h.length) {
      const d = Object.fromEntries(Object.entries(s ?? {}).filter(([m, g]) => !React$1.isValidElement(g))), y = e.t(f, d, p), b = o(y, h, 0);
      return React$1.createElement(React$1.Fragment, null, b.map((m, g) => React$1.createElement(React$1.Fragment, { key: g }, m)));
    }
    return e.t(f, s, p);
  }
  return Object.assign({
    airport: e,
    initialOptions: t,
    setLocale: r,
    t: l,
    fn: a,
    fc: n
  }, c);
}
useAirport$1.useAirport = useAirport;
Object.defineProperty(AirportSubtree$1, "__esModule", { value: !0 });
AirportSubtree$1.AirportSubtree = void 0;
const airport_js_1 = cjs, React = React__default, AirportProvider_1 = AirportProvider, useAirport_1 = useAirport$1;
function AirportSubtree({ locale: e, name: t, children: r }) {
  const [c, u] = React.useReducer((l) => l + 1, () => 0), { initialOptions: a } = useAirport_1.useAirport(), n = React.useMemo(() => {
    const l = Object.assign(Object.assign({}, a), { name: t, locale: e });
    return Object.freeze(l);
  }, [a]), i = React.useMemo(() => new airport_js_1.Airport(n), [n]), o = React.useCallback((l) => {
    i.changeLocale(l), u();
  }, [i]);
  return React.useEffect(() => {
    e && i.getLocale() !== e && o(e);
  }, [e]), React.createElement(AirportProvider_1.AirportContext.Provider, { value: {
    airport: i,
    initialOptions: n,
    setLocale: o
  } }, r);
}
AirportSubtree$1.AirportSubtree = AirportSubtree;
(function(e) {
  var t = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(n, i, o, l) {
    l === void 0 && (l = o), Object.defineProperty(n, l, { enumerable: !0, get: function() {
      return i[o];
    } });
  } : function(n, i, o, l) {
    l === void 0 && (l = o), n[l] = i[o];
  }), r = commonjsGlobal && commonjsGlobal.__exportStar || function(n, i) {
    for (var o in n)
      o !== "default" && !Object.prototype.hasOwnProperty.call(i, o) && t(i, n, o);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.useAirport = e.AirportSubtree = e.AirportContext = e.AirportProvider = void 0;
  var c = AirportProvider;
  Object.defineProperty(e, "AirportProvider", { enumerable: !0, get: function() {
    return c.AirportProvider;
  } }), Object.defineProperty(e, "AirportContext", { enumerable: !0, get: function() {
    return c.AirportContext;
  } });
  var u = AirportSubtree$1;
  Object.defineProperty(e, "AirportSubtree", { enumerable: !0, get: function() {
    return u.AirportSubtree;
  } });
  var a = useAirport$1;
  Object.defineProperty(e, "useAirport", { enumerable: !0, get: function() {
    return a.useAirport;
  } }), r(cjs, e);
})(cjs$1);
export {
  cjs$1 as c,
  getDefaultExportFromCjs as g
};
